import request from "@/utils/request"

// 标签耗材核销
export const verifyMaterial = function(params) {
  return request('post', '/api/code_trace/verified', params)
}